import React from 'react';
import { UserRound } from 'lucide-react';

export default function ProfileIcon() {
  return (
    <div className="h-11 w-11 rounded-full bg-[#44231E] flex items-center justify-center">
      <UserRound size={22} color="#EFEBE0" strokeWidth={2} />
    </div>
  );
}
